<template>
  <div class="contract-receive-bd tb" v-if="funcView.contract_receive_list">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <el-form-item>
          <el-button type="primary" :disabled="tableSelect.length === 0" @click="waitSelectEvent()" v-if="funcView.contract_receive_receipt">{{ funcView.contract_receive_receipt }}</el-button>
        </el-form-item>
        <!-- 配置项 -->
        <el-form-item style="float: right; margin-right: 0">
          <custom-column ref="column"></custom-column>
        </el-form-item>
        <!-- 搜索栏 -->
        <el-form-item style="float: right">
          <el-input :placeholder="$t('crm_contract_receive.ji_shen_hao')" v-model="formSearch.search" clearable @keyup.enter.native="onPageChange({ page: 1 })" style="width: 280px">
            <template slot="append">
              <div @click="onPageChange({ page: 1 })">
                <i class="icon icon-search"></i>
              </div>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item style="float: right">
          <switch-button :link="$refs.container"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 更多筛选 -->
    <switch-container ref="container" @search="onPageChange({ page: 1 })" @clear="clearFilter()">
      <el-form :inline="true" label-position="top">
        <el-form-item :label="$t('crm_contract_receive.he_tong_bian_hao')">
          <el-input style="width: 100%" v-model="formSearch.contractNo" clearable></el-input>
        </el-form-item>
        <el-form-item :label="$t('crm_contract_receive.GPSdi_zhi')">
          <el-input style="width: 100%" v-model="formSearch.gpsAddress" clearable></el-input>
        </el-form-item>
      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table
        type="checkbox"
        v-model="tableSelect"
        tableCode="contract_receive"
        :data="tableList"
        @sort="sortChange"
        @filter="filterChange"
        @column="setColumn"
        height="100%"
        :slots="['contractNo']"
      >
        <el-table-column :label="$t('Common.com_handle')" min-width="80" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="waitEvent(scope.row)" v-if="funcView.contract_receive_receipt">{{ funcView.contract_receive_receipt }}</el-button>
          </template>
        </el-table-column>
        <template v-slot:contractNo="scope">
          <div class="cell-link" @click="jump('/contractdetail', { contractId: scope.row.orderId, contractClass: scope.row.orderType, parentPath: $route.path })">
            {{ scope.row.contractNo }}
          </div>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins.js';

export default {
  name: 'contractreceive',
  mixins: [resetFormSearchMixins],
  data() {
    return {
      tableCode: 'contract_receive',
      tableSelect: [],
      formSearch: {
        search: '',
        orderBy: '',
        orderType: '',
        contractNo: '',
        gpsAddress: '',
        pageSize: 20,
        pageNum: 1,
      },

      tableList: [],
      totalRows: null,

      dialogVisible: false,
      dialogModel: {},
      dialogData: {},
    };
  },
  mounted: function () {
    this.getTableColumn();
    this.getFuncView();
    this.getTableList();

  },
  methods: {
    // 返库收货
    waitEvent: function (data) {
      const tips = [this.$t('crm_contract_receive.qrdsbbhwodjxsh', [data.bodyNum])];
      const shipmentMoment = this.$moment(data.shipmentTime);
      const lastCleanMoment = this.$moment(data.lastCleanStartTime);

      // 计算两个日期的差值，单位为天数
      const daysDifference = shipmentMoment.diff(lastCleanMoment, 'days');

      // 出库日期 - 最后清洁日期 >=1 天
      if (daysDifference >= 1) {
        tips.push(this.$t('crm_contract_receive.qjsjknwscwjchzjxshcz'));
      }
      this.$showConfirm(tips)
        .then(() => {
          this.$postJSON(`${apis.DeviceReceiveWait}/${data.deviceId}`).then((res) => {
            if (res.code === 0) {
              this.$message({
                message: this.$t('Common.com_handle_success'),
                type: 'success',
              });
              this.getTableList();
            }
          });
        })
        .catch(() => {});
    },
    // 返库收货（批量）
    waitSelectEvent: function () {
      const tips = [this.$t('crm_contract_receive.qrdsbbhwodjxsh', [this.tableSelect.map((t) => t.bodyNum).join('、')])];
      // 检查是否存在差值大于等于1天的情况
      const exists = this.tableSelect.some(item => {
        // 使用 moment 对日期进行解析
        const shipmentMoment = this.$moment(item.shipmentTime);
        const lastCleanMoment = this.$moment(item.lastCleanStartTime);
        // 计算两个日期的差值，单位为天数
        const daysDifference = shipmentMoment.diff(lastCleanMoment, 'days');
        // 判断是否差值大于等于1天
        return daysDifference >= 1;
      });
      if (exists) {
        tips.push(this.$t('crm_contract_receive.qjsjknwscwjchzjxshcz'));
      }
      this.$showConfirm(tips)
        .then(() => {
          this.$postJSON(
            apis.DeviceReceiveWaitBatch,
            this.tableSelect.map((t) => t.deviceId)
          ).then((res) => {
            if (res.code === 0) {
              this.$message({
                message: this.$t('Common.com_handle_success'),
                type: 'success',
              });
              this.getTableList();
            }
          });
        })
        .catch(() => {});
    },
    // 获取表格数据列表
    getTableList: function () {
      this.$getJSON(apis.DeviceReceivePage, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    onPageChange({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
  },
};
</script>

<style lang="scss">
@import 'style/colors.scss';
</style>
